import { render, staticRenderFns } from "./TheContainerAdmin.vue?vue&type=template&id=81a72d7c&scoped=true"
import script from "./TheContainerAdmin.vue?vue&type=script&lang=js"
export * from "./TheContainerAdmin.vue?vue&type=script&lang=js"
import style0 from "./TheContainerAdmin.vue?vue&type=style&index=0&id=81a72d7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81a72d7c",
  null
  
)

export default component.exports